module.exports = __webpack_public_path__ + "img/about_bg04.e34839c0.png";